// Visitor clean-up (go live, Ben 2026-10-21): placeholder and help text never shows on the storefront.
// It runs only when the theme setting "Show placeholder markers" is off, never in the theme editor, never for
// automation (navigator.webdriver, so QA still sees every marker) and never with ?vita_markers=1.
// 1. Any element whose own text is a placeholder ([In square brackets], [TO CONFIRM...], SHOOT / MOOD notes, demo
//    credits like "First name, initial") is hidden.
// 2. A review or quote card whose text was a placeholder is hidden whole (no fake reviews, ever).
// 3. A section left with no visible text and no media is hidden.
(() => {
  try {
    if (navigator.webdriver || new URLSearchParams(location.search).get('vita_markers') === '1') return;
    const PH = /\[[^\]\n]{2,}\]|TO CONFIRM|^\s*(SHOOT|MOOD)\b|shoot needed|dates to confirm|first name, initial|pulled live|appears here|review body|^\s*button label\s*$|^\s*\$\[|\bxx\.xx\b|\[x\.x\]|^\s*UGC\s*$/i;
    const CARD = '.vita-review-card, [class*="review-card"], [class*="__review"], [class*="testimonial"], blockquote, figure';
    const hide = (e) => { e.hidden = true; e.style.setProperty('display', 'none', 'important'); };
    const sweep = () => {
      const w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      const hits = [];
      while (w.nextNode()) {
        const n = w.currentNode; const t = n.textContent.trim();
        if (t.length < 2 || !PH.test(t)) continue;
        const e = n.parentElement;
        if (!e || e.closest('script,style,noscript,template,[data-vita-keep]')) continue;
        hits.push(e);
      }
      for (const e of hits) {
        const card = e.closest(CARD);
        hide(card && !card.matches('figure') ? card : e);
        // a reviews rail built on demo cards is hidden whole until real reviews exist
        const sec = e.closest('.shopify-section');
        if (sec && /review/i.test((sec.firstElementChild && sec.firstElementChild.className) + ' ' + sec.id)) hide(sec);
      }
      // a pharmacist rail with no portrait photos yet looks unfinished: hidden until the photos are added
      document.querySelectorAll('.vita-pharmacists').forEach((sec) => {
        const photos = [...sec.querySelectorAll('img')].filter((i) => i.getAttribute('src'));
        if (photos.length === 0) hide(sec.closest('.shopify-section') || sec);
      });
      document.querySelectorAll('main > .shopify-section').forEach((s) => {
        if (s.hidden) return;
        const text = (s.innerText || '').replace(/\s+/g, '');
        if (text.length === 0 && !s.querySelector('img, picture, video, svg, iframe, canvas')) hide(s);
      });
    };
    const run = () => { sweep(); setTimeout(sweep, 1500); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  } catch (e) { /* never break the page */ }
})();
